import { render, staticRenderFns } from "./iconLegales.vue?vue&type=template&id=aad84276&scoped=true&"
import script from "./iconLegales.vue?vue&type=script&lang=js&"
export * from "./iconLegales.vue?vue&type=script&lang=js&"
import style0 from "./iconLegales.vue?vue&type=style&index=0&id=aad84276&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad84276",
  null
  
)

export default component.exports